var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { ODModal, ODModalBody, ODModalFooter, ODModalHeader } from '..';
import { useBorderRadius } from '../../../hooks/useCSSStrings';
import { ODIcon, ODIcons } from '../../../icons';
import { ODButton, ODButtonTheme } from '../../misc';
import { ODLongClickOverlay } from '../../misc/ODLongClickOverlay';
var Message = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #2f353a;\n"], ["\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #2f353a;\n"])));
export function useODModalConfirm(options) {
    var title = options.title, message = options.message, yes = options.yes, no = options.no, size = options.size, _a = options.icon, icon = _a === void 0 ? ODIcons.MaterialError : _a, rounded = options.rounded, longClickTime = options.longClickTime, longClickColor = options.longClickColor, _b = options.bodyStyle, bodyStyleIn = _b === void 0 ? {} : _b;
    var _c = React.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var onClickYes = React.useRef(function () { return undefined; });
    var onClickNo = React.useRef(function () { return undefined; });
    var _d = React.useState(title), confirmTitle = _d[0], setConfirmTitle = _d[1];
    var _e = React.useState(message), confirmMessage = _e[0], setConfirmMessage = _e[1];
    var _f = React.useState(yes), confirmYes = _f[0], setConfirmYes = _f[1];
    var _g = React.useState(no), confirmNo = _g[0], setConfirmNo = _g[1];
    var _h = React.useState(bodyStyleIn), bodyStyle = _h[0], setBodyStyle = _h[1];
    var confirm = React.useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, t = _b.title, m = _b.message, y = _b.yes, n = _b.no, bs = _b.bodyStyle;
        if (t !== undefined) {
            setConfirmTitle(t);
        }
        if (m !== undefined) {
            setConfirmMessage(m);
        }
        if (y !== undefined) {
            setConfirmYes(y);
        }
        if (n !== undefined) {
            setConfirmNo(n);
        }
        if (bs !== undefined) {
            setBodyStyle(bs);
        }
        return new Promise(function (resolve) {
            onClickYes.current = function () {
                setIsOpen(false);
                resolve(true);
            };
            onClickNo.current = function () {
                setIsOpen(false);
                resolve(false);
            };
            setIsOpen(true);
        });
    }, []);
    var leftButtonStyle = {
        borderBottomLeftRadius: rounded ? useBorderRadius('normal') : 0,
    };
    var rightButtonStyle = {
        borderBottomRightRadius: rounded ? useBorderRadius('normal') : 0,
    };
    var Component = React.useState(function () {
        return function (confirmProps) {
            var hasLeftButton = !!confirmProps.no;
            var rButtonStyle = hasLeftButton ? { width: '65%' } : { width: '100%' };
            return (React.createElement(ODModal, { isOpen: confirmProps.isOpen, toggle: function () {
                    onClickNo.current();
                }, size: size, rounded: rounded },
                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(ODModalHeader, { title: confirmProps.title, onClose: function () { return onClickNo.current(); }, headerBottomPadding: 30 },
                        React.createElement(ODIcon, { icon: icon, style: { fontSize: 60 } })),
                    React.createElement(ODModalBody, { style: confirmProps.bodyStyle },
                        React.createElement(Message, null, confirmProps.message)),
                    React.createElement(ODModalFooter, null,
                        hasLeftButton && (React.createElement(ODButton, { style: __assign({ width: '35%' }, leftButtonStyle), theme: ODButtonTheme.Cancel, onClick: function () { return onClickNo.current(); } }, confirmProps.no)),
                        longClickTime && (React.createElement(ODLongClickOverlay, { longClickTime: longClickTime, color: longClickColor || '#00000080', onLongClick: function () { return onClickYes.current(); }, style: __assign({ width: '65%' }, rButtonStyle) },
                            React.createElement(ODButton, { style: __assign({ width: '100%' }, rButtonStyle), theme: ODButtonTheme.Primary }, confirmProps.yes))),
                        !longClickTime && (React.createElement(ODButton, { style: __assign(__assign({}, rButtonStyle), rButtonStyle), theme: ODButtonTheme.Primary, onClick: function () { return onClickYes.current(); } }, confirmProps.yes))))));
        };
    })[0];
    var props = {
        isOpen: isOpen,
        setIsOpen: function (v) {
            setIsOpen(v);
        },
        title: confirmTitle,
        message: confirmMessage,
        yes: confirmYes,
        no: confirmNo,
        bodyStyle: bodyStyle,
    };
    return { Component: Component, confirm: confirm, props: props };
}
var templateObject_1;
//# sourceMappingURL=ODModalConfirm.js.map